export const ACTIVITY_HEARTBEAT_THROTTLE_MS = 60 * 60 * 1000;

export interface ActivityHeartbeatGateInput {
	lastInteractionAt: null | number;
	lastSentAt: null | number;
	now: number;
}

export const shouldSendActivityHeartbeat = ({
	lastInteractionAt,
	lastSentAt,
	now
}: ActivityHeartbeatGateInput): boolean => {
	const hasInteractionSinceLastSend =
		lastInteractionAt !== null && (lastSentAt === null || lastInteractionAt > lastSentAt);
	const throttleWindowElapsed = lastSentAt === null || now - lastSentAt >= ACTIVITY_HEARTBEAT_THROTTLE_MS;
	return hasInteractionSinceLastSend && throttleWindowElapsed;
};
